import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-viewalldailog',
  templateUrl: './viewalldailog.component.html',
  styleUrls: ['./viewalldailog.component.scss']
})
export class ViewalldailogComponent implements OnInit {
  data2: any;
  constructor(public dialogRef: MatDialogRef<ViewalldailogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,public campuscctvserviceservice: CampuscctvserviceService,private spinner: NgxSpinnerService,) { }
  ngOnInit(): void {
    console.log('viewall', this.data);
    this.spinner.show();
    this.campuscctvserviceservice.viewall(this.data.cctvDetId).subscribe((res)=>{
      this.data2=res;
      this.spinner.hide();
      console.log('data2',this.data2);
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  
}
